import { Component, OnInit, OnChanges, SimpleChanges, Input, Output, EventEmitter, ViewChild, Inject } from '@angular/core';
import { DatePickerType } from '../model/features-impl';
import { ObjectInputComponent } from '../object-input/object-input.component';
import { EX_CONTROL_CONFIG, ExControlConfig } from 'types';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS, MatFormFieldDefaultOptions } from '@angular/material/form-field';

@Component({
  selector: 'i-object-input-ex',
  templateUrl: './object-input-ex.component.html',
  styleUrls: ['./object-input-ex.component.scss'],
})
export class ObjectInputComponentEx implements OnInit, OnChanges {
  @ViewChild('iObjectInput') iObjectInput: ObjectInputComponent;
  @Input() inpPath: string;
  @Input() inpPathForValidation: string;
  @Input() inpModel: string | null;
  @Input() inpParse: (value: string | null) => string | null;
  @Input() inpFormat: (value: string | null, monthFormat: 'letters' | null) => string | null;
  @Input() datePickerType: DatePickerType = DatePickerType.None;
  @Input() inpNullable: string = '';
  @Input() inpClass: string = '';
  @Input() inpLabel: string;
  @Input() inpTabIndex: number = 0;
  @Output() inpModelChange = new EventEmitter<string | null>();

  nullable: boolean = false;
  disabled: boolean = false;
  exType: ExControlConfig['type'] = 'default';
  readonly appearance?: MatFormFieldDefaultOptions['appearance'];

  constructor(
    @Inject(EX_CONTROL_CONFIG) private exControlConfig: ExControlConfig,
    @Inject(MAT_FORM_FIELD_DEFAULT_OPTIONS) private options: MatFormFieldDefaultOptions,
  ) {
    this.appearance = this.options.appearance;
  }

  ngOnInit() {
    this.exType = this.exControlConfig.type;
    this.nullable = this.inpNullable.length > 0;
    this.disabled = this.checkForReverse(this.inpModel === null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    let inpModelChange = changes['inpModel'];
    if (inpModelChange) {
      this.disabled = this.checkForReverse(this.inpModel === null);
    }
  }

  changed() {
    this.inpModelChange.emit(this.inpModel);
  }

  disabledChanged() {
    this.inpModel = this.checkForReverse(this.disabled) ? null : '';
    this.inpModelChange.emit(this.inpModel);
  }

  checkForReverse(value: boolean): boolean {
    return this.exType === 'slider' || this.exType === 'combined-slider' ? !value : value;
  }
}
